module.exports = __webpack_public_path__ + "img/menuIcon21.b5369dc2.png";